<template>
    <div v-if="!showRouterView" class="relative mx-auto appWidth">
        <div class="absolute top-3 right-3 rounded-full px-2 py-1 bg-primary cursor-pointer" @click="skipCountdown">{{
            $t('Skip') }} {{ countdown }}</div>
        <img src="@/assets/images/webp/promo4.jpg" class="w-full" alt="Wallpaper" />
    </div>

    <router-view v-else />

    <Toast position="bottom-right"></Toast>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'
import EventBus from '@/libs/AppEventBus'
import socket from "@/libs/socket";


import { Capacitor } from '@capacitor/core'
import { LiveUpdates } from '@capacitor/live-updates'

if (Capacitor.isNativePlatform() && LiveUpdates?.sync) {
  LiveUpdates.sync().then((result) => {
    if (result.active) {
      console.log('✅ Update applied')
      location.reload()
    } else {
      console.log('🔄 No update found')
    }
  }).catch(err => {
    console.warn('LiveUpdate Error:', err)
  })
} else {
  console.log('⚠️ LiveUpdates plugin not available (web browser mode)')
}

const showRouterView = ref(process.env.VUE_APP_ENV == 'production' ? false : true)
const countdown = ref(3)
let countdownTimer = null

onMounted(() => {
      const phone = localStorage.getItem("userPhone");

    socket.on("player_left_game_notice", (data) => {
        if (phone == data.member_account) {
            if (data.status == "already_in_game") {
                window.location.reload();
                socket.emit("player_left_game", {
                    member_account: phone,
                    status: "leftgame",
                });
            }
        }
    });
    EventBus.on('show-toast', showToast)
    startCountdown()
})

onBeforeUnmount(() => {
    EventBus.off('show-toast', showToast)
    clearInterval(countdownTimer)
})

const showToast = (event) => {
    if (event.severity === 'error') {
        toast.error(event.detail, {
            autoClose: 8000,
            dangerouslyHTMLString: true,
            position: toast.POSITION.BOTTOM_CENTER
        })
    } else if (event.severity === 'warn') {
        toast.warn(event.detail, {
            autoClose: 8000,
            dangerouslyHTMLString: true,
            position: toast.POSITION.BOTTOM_CENTER
        })
    } else if (event.severity === 'info') {
        toast.info(event.detail, {
            autoClose: 8000,
            dangerouslyHTMLString: true,
            position: toast.POSITION.BOTTOM_CENTER
        })
    } else {
        toast.success(event.detail, {
            autoClose: 8000,
            dangerouslyHTMLString: true,
            position: toast.POSITION.BOTTOM_CENTER
        })
    }
}

const startCountdown = () => {
    countdownTimer = setInterval(() => {
        if (countdown.value > 1) {
            countdown.value--
        } else {
            clearInterval(countdownTimer)
            showRouterView.value = true
        }
    }, 1000)
}

const skipCountdown = () => {
    clearInterval(countdownTimer)
    showRouterView.value = true
}
</script>
